import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {
    AppAlertService,
    ParametersService,
    SubtitlesService,
    ZonesService
} from "../../core";

@Component({
    selector: 'zone',
    templateUrl: './zone.component.html',
    styleUrls: ['./zone.component.scss']
})
export class ZoneComponent implements OnInit {

    constructor(
        private appAlert: AppAlertService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
        }
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    getControlModeName(): string {
        const array = [3109, 1401, 809, 4325];
        return this.subtitle(array[this.zones.zonesParameter.value]);
    }

    showAlertControllerMode(): void {
        const message = '<div class="text-align-center">'
            + this.subtitle(3960) + ' '
            + this.getControlModeName() + '<br/>'
            + this.subtitle(3961) + '</div>';

        this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(1006),
            this.zones.openControl.bind(this.zones), this.subtitles.setSubtitle(71), null);
    }
}
